import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VersionsModule } from '@core/components/versions/versions.module';
import { FilesModule } from '@core/components/files/files.module';
import { CommonsModule } from '@core/components/commons/commons.module';
import { VersionFilesModule } from '@core/components/versions/version-files/version-files.module';
// import { ShareModule } from '@core/components/share/share.module';

import { PluginShareFeedbackSelectFilesSectionComponent } from './select-files/select-files.component';


@NgModule({
    imports: [
      CommonModule,
      VersionsModule,
      FilesModule,
      CommonsModule,
      VersionFilesModule,
      // ShareModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
      PluginShareFeedbackSelectFilesSectionComponent
    ],
    exports: [
      PluginShareFeedbackSelectFilesSectionComponent
    ],
    providers: [
    ]

})
export class ShareFeedbackAppSectionsModule { }
